import { Col, Container, Row } from 'react-bootstrap';

import ChangePassword from './ChangePassword';

const UserSettings = () => {
  return (
    <div className="main-content">
      <Container fluid>
        <Row className="justify-content-center">
          <Col xs={12} md={5} xl={4} className="my-5">
            <ChangePassword />
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default UserSettings;
